import { IGetProdutoServicoDropDownUseCase } from "../../../presentation/useCases/read/get_produto_servico_drop_down_use_case";
import { DropDownProdutoServicoDto } from "../../models/dropdown_produto_servico";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetProdutoServicoDropDownUseCase
 */

export class GetProdutoServicoDropDownUseCase implements IGetProdutoServicoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getProdutoServicoDropDown(tipo?: string): Promise<DropDownProdutoServicoDto[]> {
    return await this.repository.getProdutoServicoDropDown(tipo);
  }

}
